import { VuexModule, Mutation, Module } from "vuex-module-decorators";
import Store from "@/store/index.ts";

@Module({ dynamic: true, store: Store, name: "calendar", namespaced: true })
export default class CalendarModule extends VuexModule {
  private calendarId = "";

  @Mutation
  public setCalendarId(id: string): void {
    this.calendarId = id;
  }

  get getCalendarId(): string {
    return this.calendarId;
  }
}
